import { render, staticRenderFns } from "./RequestsPanel.vue?vue&type=template&id=1d66d6d2&scoped=true&"
import script from "./RequestsPanel.vue?vue&type=script&lang=js&"
export * from "./RequestsPanel.vue?vue&type=script&lang=js&"
import style0 from "./RequestsPanel.vue?vue&type=style&index=0&id=1d66d6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66d6d2",
  null
  
)

export default component.exports